document.addEventListener("DOMContentLoaded", function () {
    const formSelector = document.getElementById("contact-form-selector");
    const b2cForm = document.querySelector(".contact-form--wrapper");
    const b2bFormContainer = document.getElementById("b2b-form-container");
    const b2bForm = document.getElementById("marlot-b2b-form");

    if (!formSelector || !b2cForm || !b2bFormContainer) return;

    const currentLanguage = (window.Shopify && Shopify.locale) ? Shopify.locale : "es";

    function showB2C() {
        b2cForm.style.display = "block";
        b2bFormContainer.style.display = "none";
    }

    function showB2B() {
        b2cForm.style.display = "none";
        b2bFormContainer.style.display = "block";
    }

    // Manejo de selección de formulario
    formSelector.addEventListener("click", function (e) {
        e.preventDefault();
        const target = e.target;

        if (target.tagName !== "A") return;

        const value = target.getAttribute("data-value");

        // Reset de clases underline en todos los elementos
        formSelector.querySelectorAll("a").forEach(a => a.classList.remove("underline"));
        target.classList.add("underline");

        if (value === "b2c") {
            showB2C();
        } else if (value === "b2b") {
            showB2B();
        }
    });

    // ** Detectar el parámetro de la URL o el hash **
    const params = new URLSearchParams(window.location.search);
    const formType = params.get("form"); // Obtener el valor del parámetro "form"
    const hash = window.location.hash;   // Obtener el hash de la URL

    // Resetear todas las clases underline antes de añadir la clase correspondiente
    formSelector.querySelectorAll("a").forEach(a => a.classList.remove("underline"));

    if (formType === "b2b" || hash === "#business") {
        // Mostrar directamente el formulario B2B
        showB2B();
        formSelector.querySelector('[data-value="b2b"]').classList.add("underline");
    } else {
        // Por defecto, mostrar el formulario B2C
        showB2C();
        formSelector.querySelector('[data-value="b2c"]').classList.add("underline");
    }

    if (!b2bForm) return;

    const statusEl = document.getElementById("marlot-b2b-status");
    const submitButton = b2bForm.querySelector('input[type="submit"]');

    function showStatus(message) {
        statusEl.textContent = message;
        statusEl.style.display = "block";
    }

    b2bForm.addEventListener("submit", async function (e) {
        e.preventDefault();

        const firstname = b2bForm.elements.firstname.value.trim();
        const email = b2bForm.elements.email.value.trim();
        const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        // Validación mínima cliente: nombre no vacío y email con formato válido
        if (!firstname || !emailValid) {
            if (b2bForm.reportValidity) b2bForm.reportValidity();
            return;
        }

        const payload = {
            firstname: firstname,
            email: email,
            phone: b2bForm.elements.phone.value.trim(),
            pais: b2bForm.elements.pais.value.trim(),
            c__tipo_de_cliente: b2bForm.elements.c__tipo_de_cliente.value,
            website: b2bForm.elements.website.value.trim(),
            perfil_de_instagram: b2bForm.elements.perfil_de_instagram.value.trim(),
            comentarios: b2bForm.elements.comentarios.value.trim(),
            language: currentLanguage,
            website_confirm: b2bForm.elements.website_confirm.value // honeypot: debe ir vacío
        };

        const originalLabel = submitButton.value;
        submitButton.disabled = true;
        submitButton.value = b2bForm.dataset.sendingLabel || originalLabel;
        statusEl.style.display = "none";

        try {
            const response = await fetch(b2bForm.dataset.endpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
                mode: "cors",
                credentials: "omit"
            });
            const data = await response.json().catch(() => null);

            if (response.ok && data && data.success) {
                // Éxito: ocultar formulario y selector, mostrar mensaje de éxito
                b2bForm.querySelector(".contact-form__content").style.display = "none";
                formSelector.style.display = "none";
                showStatus(b2bForm.dataset.successMessage);
            } else {
                // Error del servidor: mensaje y formulario reutilizable
                showStatus((data && data.error) || b2bForm.dataset.errorMessage);
            }
        } catch (err) {
            showStatus(b2bForm.dataset.errorMessage);
        } finally {
            submitButton.disabled = false;
            submitButton.value = originalLabel;
        }
    });
});
